import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("カンタン")
const _hoisted_2 = /*#__PURE__*/_createElementVNode("b", null, "無料査定", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("にお申込み")
const _hoisted_4 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-center q-mb-lg" }, [
  /*#__PURE__*/_createTextVNode(" 下記のフォームに必要事項をご記入の上、お見積り依頼ボタンを押してください。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 車検証に未記入の項目がある場合は空欄で結構です。 ")
], -1)
const _hoisted_6 = { class: "row q-col-gutter-x-md q-col-gutter-y-sm q-mb-sm" }
const _hoisted_7 = { class: "col-12 col-sm-6" }
const _hoisted_8 = { class: "col-12 col-sm-6" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = {
  class: "q-mr-sm",
  style: {"flex":"1 1 36.9%"}
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 初度登録年 ")
const _hoisted_12 = { style: {"flex":"1 1 20%"} }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 月 ")
const _hoisted_14 = { class: "col-12 col-sm-6" }
const _hoisted_15 = { class: "col-12 col-sm-6" }
const _hoisted_16 = { class: "row q-col-gutter-x-sm" }
const _hoisted_17 = { class: "col-6 col-sm-6" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 型式指定番号 ")
const _hoisted_19 = { class: "col-6 col-sm-6" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 類別区分番号 ")
const _hoisted_21 = { class: "col-12 col-sm-6" }
const _hoisted_22 = { class: "row q-gutter-x-sm" }
const _hoisted_23 = { style: {"flex":"1 1 26%"} }
const _hoisted_24 = { style: {"flex":"1 1 26%"} }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 総走行距離 ")
const _hoisted_26 = { class: "row q-col-gutter-x-md q-col-gutter-y-sm q-mb-md" }
const _hoisted_27 = { class: "col-12 col-sm-6" }
const _hoisted_28 = { class: "row q-col-gutter-x-sm" }
const _hoisted_29 = { class: "col-6 col-sm-6" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" お名前 ")
const _hoisted_31 = { class: "col-6 col-sm-6" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" フリガナ ")
const _hoisted_33 = { class: "col-12 col-sm-6" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" メールアドレス ")
const _hoisted_35 = { class: "col-12 col-sm-6" }
const _hoisted_36 = { class: "row q-col-gutter-x-sm" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" 携帯電話番号 ")
const _hoisted_38 = { class: "col-6 col-sm-6" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" 郵便番号 ")
const _hoisted_40 = { class: "text-center q-my-lg" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", { class: "text-center q-mt-lg q-mb-none" }, [
  /*#__PURE__*/_createTextVNode(" お客様が迷惑メール対策等で、ドメイン指定受信を設定されている場合に、"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" メールが正しく届かないことがございます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 以下のドメインを受信できるように設定してください。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 「＠scrapped.net」"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 各端末のドメイン指定の設定方法は端末の説明書等をご確認ください。 ")
], -1)

import { inject } from 'vue'
import { useRouter } from 'vue-router'
import { useAsyncTask } from 'vue-concurrency'
import { Dialog, QSelectProps } from 'quasar'
import api from '@/estimate/api'
import { SelectCar } from '@/estimate/components'
import {
  ScrapInputKey,
  ScrapInput,
  ScrapImageKey,
  ScrapImage,
  ScrapValidationKey,
  ScrapValidation,
  // ScrapIncentiveKey,
  // ScrapIncentive,
} from '@/estimate/composables'

/** 入力データ */

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { inputData, initInputData } = inject(ScrapInputKey) as ScrapInput
/** 画像データ */
const { initImageData } = inject(ScrapImageKey) as ScrapImage
/** フォームの検証 */
const {
  errors,
  validate,
  // hasError
} = inject(ScrapValidationKey) as ScrapValidation
/** インセンティブ */
// const { incentives, totalIncentive } = inject(ScrapIncentiveKey) as ScrapIncentive

/** 車の状態 */
const carConditionOptions = inject('carConditionOptions')
/** 搬入方法 */
const carBringTakeOptions = inject('carBringTakeOptions')
/** 初年度登録年 */
const carRegistYearOptions = inject('carRegistYearOptions') as QSelectProps['options']
/** 初年度登録月 */
const carRegistMonthOptions = inject('carRegistMonthOptions') as QSelectProps['options']

/** 郵便番号取得タスク */
const zipcloudTask = useAsyncTask(async () => {
  return api.external
    .zipcloud(inputData.userZip)
    .then(res => {
      inputData.userPref = res.address1
      inputData.userAddr = res.address2 + res.address3
    })
    .catch(err => {
      inputData.userPref = ''
      inputData.userAddr = ''
      return Promise.reject(err)
    })
})

/** 査定申込タスク */
const postOrderTask = useAsyncTask(async () => {
  return api.order
    .send(inputData)
    .then(() => {
      // 完了画面へ
      router.push('completed')
      // データをリセット
      initInputData()
      initImageData()
    })
    .catch(err => {
      // エラーダイアログを表示
      Dialog.create({ message: err })
    })
})

const router = useRouter()

/** フォーム送信前の確認 */
async function toComfirm() {
  try {
    // 検証
    if (validate('index')) {
      throw Object.values(errors).filter(Boolean).join('<br>')
    }
    // 郵便番号から自動入力
    await zipcloudTask.perform()
    // 確認ダイアログ
    // onOk: 送信処理
    openConfirmDialog().onOk(postOrderTask.perform)
  } catch (err) {
    // エラーダイアログを表示
    Dialog.create({ message: err as string, html: true })
  }
}

/** さらに詳細入力 */
// async function toMoreInput() {
//   try {
//     // 検証
//     if (validate('index')) {
//       throw Object.values(errors).filter(Boolean).join('<br>')
//     }
//     // 郵便番号から自動入力
//     await zipcloudTask.perform()
//     // 詳細入力へ
//     router.push('form')
//   } catch (err) {
//     // エラーダイアログを表示
//     Dialog.create({ message: err as string, html: true })
//   }
// }

/** 確認ダイアログを開く */
function openConfirmDialog() {
  return Dialog.create({
    title: '見積り依頼確認',
    message: `<p>${inputData.userName}&emsp;様<br />ご連絡先「${inputData.userMob}」にて承ります。</p><p>昭和メタルに見積りを依頼いたします。よろしいですか？</p>`,
    html: true,
    cancel: '入力し直す',
    ok: { label: '見積り依頼する', unelevated: true },
  })
}

return (_ctx: any,_cache: any) => {
  const _component_common_radio = _resolveComponent("common-radio")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.root)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.heading)
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.headingInner)
      }, _hoisted_4, 2)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.body)
    }, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_common_radio, {
            icon: "",
            class: _normalizeClass(_ctx.$style.spFontSize),
            options: _unref(carConditionOptions),
            error: _unref(errors).carCondition,
            modelValue: _unref(inputData).carCondition,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(inputData).carCondition) = $event)),
            label: `車の状態`
          }, null, 8, ["class", "options", "error", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_q_select, {
                label: "初度登録年",
                outlined: "",
                "hide-bottom-space": "",
                "emit-value": "",
                "map-options": "",
                for: "carRegistYear",
                error: _unref(errors).carRegistYear !== null,
                "error-message": _unref(errors).carRegistYear ?? undefined,
                options: _unref(carRegistYearOptions),
                modelValue: _unref(inputData).carRegistYear,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(inputData).carRegistYear) = $event))
              }, {
                label: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: "las la-hand-pointer",
                    style: {"color":"#bbb","margin-bottom":"4px","font-size":"22px"}
                  }),
                  _hoisted_11
                ]),
                _: 1
              }, 8, ["error", "error-message", "options", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_q_select, {
                label: "月",
                outlined: "",
                "hide-bottom-space": "",
                "emit-value": "",
                "map-options": "",
                for: "carRegistMonth",
                error: _unref(errors).carRegistMonth !== null,
                "error-message": _unref(errors).carRegistMonth ?? undefined,
                options: _unref(carRegistMonthOptions),
                modelValue: _unref(inputData).carRegistMonth,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(inputData).carRegistMonth) = $event))
              }, {
                label: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: "las la-hand-pointer",
                    style: {"color":"#bbb","margin-bottom":"4px","font-size":"22px"}
                  }),
                  _hoisted_13
                ]),
                _: 1
              }, 8, ["error", "error-message", "options", "modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_unref(SelectCar), {
            "car-country": _unref(inputData).carCountry,
            "onUpdate:car-country": _cache[3] || (_cache[3] = ($event: any) => ((_unref(inputData).carCountry) = $event)),
            "car-maker": _unref(inputData).carMaker,
            "onUpdate:car-maker": _cache[4] || (_cache[4] = ($event: any) => ((_unref(inputData).carMaker) = $event)),
            "car-name": _unref(inputData).carName,
            "onUpdate:car-name": _cache[5] || (_cache[5] = ($event: any) => ((_unref(inputData).carName) = $event)),
            error: _unref(errors).car
          }, null, 8, ["car-country", "car-maker", "car-name", "error"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_q_input, {
                label: "型式指定番号",
                outlined: "",
                "hide-bottom-space": "",
                for: "carTypeNum",
                mask: "#####",
                error: _unref(errors).carTypeNum !== null,
                "error-message": _unref(errors).carTypeNum ?? undefined,
                modelValue: _unref(inputData).carTypeNum,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(inputData).carTypeNum) = $event))
              }, {
                label: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: "fas fa-pen",
                    style: {"color":"#bbb","margin-bottom":"4px"}
                  }),
                  _hoisted_18
                ]),
                _: 1
              }, 8, ["error", "error-message", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_q_input, {
                label: "類別区分番号",
                outlined: "",
                "hide-bottom-space": "",
                for: "carClassNum",
                mask: "####",
                error: _unref(errors).carClassNum !== null,
                "error-message": _unref(errors).carClassNum ?? undefined,
                modelValue: _unref(inputData).carClassNum,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(inputData).carClassNum) = $event))
              }, {
                label: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: "fas fa-pen",
                    style: {"color":"#bbb","margin-bottom":"4px"}
                  }),
                  _hoisted_20
                ]),
                _: 1
              }, 8, ["error", "error-message", "modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_common_radio, {
                icon: "",
                class: _normalizeClass(_ctx.$style.spFontSize),
                modelValue: _unref(inputData).carBringTake,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(inputData).carBringTake) = $event)),
                options: _unref(carBringTakeOptions),
                error: _unref(errors).carBringTake,
                label: `搬入方法`
              }, null, 8, ["class", "modelValue", "options", "error"])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_q_input, {
                label: "総走行距離",
                "input-class": "text-right",
                outlined: "",
                "hide-bottom-space": "",
                for: "carMileage",
                type: "tel",
                mask: "#######",
                suffix: "km",
                error: _unref(errors).carMileage !== null,
                "error-message": _unref(errors).carMileage ?? undefined,
                modelValue: _unref(inputData).carMileage,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(inputData).carMileage) = $event))
              }, {
                label: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: "fas fa-pen",
                    style: {"color":"#bbb","margin-bottom":"4px"}
                  }),
                  _hoisted_25
                ]),
                _: 1
              }, 8, ["error", "error-message", "modelValue"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_q_input, {
                label: "お名前",
                outlined: "",
                "hide-bottom-space": "",
                for: "userName",
                error: _unref(errors).userName !== null,
                "error-message": _unref(errors).userName ?? undefined,
                modelValue: _unref(inputData).userName,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(inputData).userName) = $event))
              }, {
                label: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: "fas fa-pen",
                    style: {"color":"#bbb","margin-bottom":"4px"}
                  }),
                  _hoisted_30
                ]),
                _: 1
              }, 8, ["error", "error-message", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_q_input, {
                label: "フリガナ",
                outlined: "",
                "hide-bottom-space": "",
                for: "userKana",
                error: _unref(errors).userKana !== null,
                "error-message": _unref(errors).userKana ?? undefined,
                modelValue: _unref(inputData).userKana,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(inputData).userKana) = $event))
              }, {
                label: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: "fas fa-pen",
                    style: {"color":"#bbb","margin-bottom":"4px"}
                  }),
                  _hoisted_32
                ]),
                _: 1
              }, 8, ["error", "error-message", "modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createVNode(_component_q_input, {
            label: "メールアドレス",
            outlined: "",
            "hide-bottom-space": "",
            for: "userEMail",
            type: "email",
            mask: "###-####",
            error: _unref(errors).userEMail !== null,
            "error-message": _unref(errors).userEMail ?? undefined,
            modelValue: _unref(inputData).userEMail,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(inputData).userEMail) = $event))
          }, {
            label: _withCtx(() => [
              _createVNode(_component_q_icon, {
                name: "fas fa-pen",
                style: {"color":"#bbb","margin-bottom":"4px"}
              }),
              _hoisted_34
            ]),
            _: 1
          }, 8, ["error", "error-message", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", {
              class: _normalizeClass(["col-6 col-sm-6", _ctx.$style.spMarginBottom])
            }, [
              _createVNode(_component_q_input, {
                label: "携帯電話番号",
                outlined: "",
                "hide-bottom-space": "",
                for: "userMob",
                type: "tel",
                mask: "###-####-####",
                error: _unref(errors).userMob !== null,
                "error-message": _unref(errors).userMob ?? undefined,
                modelValue: _unref(inputData).userMob,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(inputData).userMob) = $event))
              }, {
                label: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: "fas fa-pen",
                    style: {"color":"#bbb","margin-bottom":"4px"}
                  }),
                  _hoisted_37
                ]),
                _: 1
              }, 8, ["error", "error-message", "modelValue"])
            ], 2),
            _createElementVNode("div", _hoisted_38, [
              _createVNode(_component_q_input, {
                label: "郵便番号",
                outlined: "",
                "hide-bottom-space": "",
                for: "userZip",
                type: "tel",
                mask: "###-####",
                error: _unref(errors).userZip !== null,
                "error-message": _unref(errors).userZip ?? undefined,
                modelValue: _unref(inputData).userZip,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(inputData).userZip) = $event))
              }, {
                label: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: "fas fa-pen",
                    style: {"color":"#bbb","margin-bottom":"4px"}
                  }),
                  _hoisted_39
                ]),
                _: 1
              }, 8, ["error", "error-message", "modelValue"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_40, [
        _createVNode(_component_q_btn, {
          unelevated: "",
          onClick: toComfirm,
          color: "brand",
          size: "lg",
          label: "お見積り依頼",
          class: _normalizeClass(_ctx.$style.confirmButton),
          "icon-right": "table_view"
        }, null, 8, ["class"])
      ]),
      _hoisted_41,
      _createVNode(_component_q_inner_loading, {
        color: "primary",
        showing: _unref(zipcloudTask).isRunning
      }, null, 8, ["showing"])
    ], 2)
  ], 2))
}
}

})